// Phase G3 Stage 3: /parent/settings — layout w/ sidebar + Outlet.
import { createFileRoute } from "@tanstack/react-router";
import { ParentSettingsLayout } from "@/screens/ParentSettings";
import { ParentRouteError } from "@/components/RouterErrorFallback";
export const Route = createFileRoute("/parent/settings")({
  errorComponent: ParentRouteError, // MA-107
  head: () => ({ meta: [{ title: "PencilWise · Parent settings" }] }),
  component: ParentSettingsLayout,
});
